import React from 'react';
import { ExternalLink, Play, FileText, Globe } from 'lucide-react';
import type { LinkPreviewData } from './types';

interface PreviewProps {
  data: LinkPreviewData;
}

export const Preview: React.FC<PreviewProps> = ({ data }) => {
  const TypeIcon = () => {
    switch (data.type) {
      case 'video':
        return <Play className="w-5 h-5 text-gray-600" />;
      case 'article':
        return <FileText className="w-5 h-5 text-gray-600" />;
      default:
        return <Globe className="w-5 h-5 text-gray-600" />;
    }
  };

  return (
    <a 
      href={data.url}
      target="_blank"
      rel="noopener noreferrer"
      className="block w-full max-w-md bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300"
    >
      <div className="relative">
        <img
          src={data.image}
          alt={data.title}
          className="w-full h-48 object-cover"
          onError={(e) => {
            e.currentTarget.src = 'https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80';
          }}
        />
        <div className="absolute top-2 right-2 bg-white/90 p-1.5 rounded-full">
          <ExternalLink className="w-4 h-4 text-gray-600" />
        </div>
        <div className="absolute top-2 left-2 bg-white/90 p-1.5 rounded-full">
          <TypeIcon />
        </div>
      </div>
      <div className="p-4">
        <h3 className="font-semibold text-lg text-gray-800 mb-2 line-clamp-2">
          {data.title}
        </h3>
        <p className="text-gray-600 text-sm line-clamp-2">
          {data.description}
        </p>
      </div>
    </a>
  );
};